import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

import { Typography } from "@/components/ui-v2";

export const classes = {
  root: "video-effect-tile-overlay",
};

const Root = styled(Box)(({ theme }) => ({
  transition: "opacity 0.3s ease",
  position: "absolute",
  zIndex: 2,
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(2),
  pointerEvents: "none",
  textAlign: "center",
  backgroundColor: theme.palette.secondary["9/50"],
}));

interface VideoEffectTileOverlayProps {
  title: string;
}

export const VideoEffectTileOverlay = (props: VideoEffectTileOverlayProps) => {
  const { title } = props;

  return (
    <Root className={classes.root}>
      <Typography sx={{ fontSize: "1em" }} variant="large">
        {title}
      </Typography>
    </Root>
  );
};
